<template>
  <div class="roleAddBox">
    <Form ref="addForm" :label-width="80" :model="formCustom" :rules="addRules" inline>
      <Form-item label="角色名称：" prop="roleName">
        <Input v-model="formCustom.roleName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <br>
      <Form-item label="角色类型：" prop="roleType">
        <Select v-model="formCustom.roleType" clearable filterable style="width: 200px">
          <Option value="2">前道</Option>
          <Option value="3">后道</Option>
        </Select>
      </Form-item>
      <br>
      <Form-item label="别名：" prop="remarks">
        <Input v-model="formCustom.remarks" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
    </Form>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="addLoading" style="margin-left: 10px" type="primary" @click="handleCommit('addForm')">
        <span v-if="!addLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {roleAdd} from '@/api/authority'

export default {
  name: 'roleAdd',
  data() {
    return {
      addLoading: false,
      formCustom: {
        roleName: '',
        remarks: '',
        roleType: ''
      },
      addRules: {
        roleName: [{required: true, message: '角色名称不能为空', trigger: 'blur'}],
        roleType: [{required: true, message: '角色类型不能为空', trigger: 'change'}]
      }
    }
  },
  mounted() {
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/authority/role',
          query: {
            current: this.$route.query.current,
            size: this.$route.query.size,
            roleName: this.$route.query.roleName
          }
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.addLoading = true
          roleAdd({
            roleName: this.formCustom.roleName,
            remarks: this.formCustom.remarks,
            roleType: this.formCustom.roleType
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.addLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.addLoading = false
              this.$router.push({name: 'role'})
            }
          }).catch(() => {
            this.addLoading = false
          })
        }
      })
    }
  }
}
</script>
